import React, { useEffect, useState } from "react";
import { fetchCmsContent } from "../services/fetchCmsContent";
import MainPageComponents from "../components/CommonComponents/MainPageComponents";


interface AccessibilityItem {
  title: string;
  slug: string;
  content: string;
}

const AccessibilityPage: React.FC = () => {
  const [accessibility, setAccessibility] = useState<AccessibilityItem | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    fetchCmsContent("Accessibility", "/api/cms/accessibility", setAccessibility, setLoading);
  }, []);

  return (
    <MainPageComponents
      title={accessibility?.title || "Accessibility"}
      content={accessibility?.content || ""}
      loading={loading}
      updated_at=""
    />);
};

export default AccessibilityPage;
